import { Query } from "@datorama/akita";
import { Observable } from "rxjs";
import { singleton } from "tsyringe";

import WishlistsBackInStockItemsStore, {
    WishlistsBackInStockItemsState,
} from "../stores/WishlistsBackInStockItemsStore";

@singleton()
class WishlistsBackInStockItemsQuery extends Query<WishlistsBackInStockItemsState> {
    constructor(protected store: WishlistsBackInStockItemsStore) {
        super(store);
    }

    selectIsProductBackInStock(
        productId: number,
        variantId: number
    ): Observable<boolean> {
        return this.select((state) => {
            const product = state.items.find(
                (item) => item.productId === productId
            );
            if (product) {
                return product.restockedProductVariants.includes(variantId);
            }
            return false;
        });
    }
}

export default WishlistsBackInStockItemsQuery;
